import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchAppraisal = createAsyncThunk(
  "appraisal-booking",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/appraisal-booking`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching appraisal data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch test drive data"
      );
    }
  }
);

export const createAppraisalBooking = createAsyncThunk(
  'appraisal-booking/store', 
  async (items, { getState, rejectWithValue }) => {
      try {
          const token = getState().auth.token || localStorage.getItem('authToken');

          const response = await axios.post(`${API_URL}/appraisal-booking/store`, items, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });
          
          return response.data;
      } catch (error) {        
          console.error('Error store test drive booking:', error);
          return rejectWithValue(error.response?.data || 'Failed to store items');
      }
  }
);

export const updateStatusAppraisalBooking = createAsyncThunk(
  'appraisal-booking/gr/update-status', 
  async (items, { getState, rejectWithValue }) => {
      try {
          const token = getState().auth.token || localStorage.getItem('authToken');

          const response = await axios.put(`${API_URL}/appraisal-booking/update-status/${items.appraisal_booking_id}`, items, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });

          return response.data;
      } catch (error) {
          console.error('Error update status appraisal booking gr:', error);
          return rejectWithValue(error.response?.data || 'Failed to update status items');
      }
  }
);

const appraisalSlice = createSlice({
  name: "appraisal",
  initialState: {
    appraisal_booking: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppraisal.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAppraisal.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appraisal_booking = action.payload;
      })
      .addCase(fetchAppraisal.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createAppraisalBooking.fulfilled, (state, action) => {        
          state.appraisal_booking.push(action.payload.ress.data);
      })
      .addCase(updateStatusAppraisalBooking.fulfilled, (state, action) => {
          const index = state.appraisal_booking.findIndex((item) => item.appraisal_booking_id === action.payload.data.appraisal_booking_id);
          if (index !== -1) {
              state.appraisal_booking[index] = { ...state.appraisal_booking[index], ...action.payload.data };
          }
          state.isLoading = false;
      });
  },
});

export default appraisalSlice.reducer;
